function initHfmSlideshows(root = document) {
  const slideshows = root.querySelectorAll('.slideshow.swiper');

  slideshows.forEach((slideshow) => {
    if (slideshow.dataset.swiperInitialized === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const autoplayEnabled = slideshow.dataset.autoplay === 'true';
    const slideCount = slideshow.querySelectorAll('.swiper-slide').length;
    const speedSeconds = parseInt(slideshow.dataset.speed, 10);
    const delay = Number.isFinite(speedSeconds) ? speedSeconds * 1000 : 7000;

    slideshow.dataset.swiperInitialized = 'true';

    new Swiper(slideshow, {
      centeredSlides: true,
      loop: slideCount > 1,
      navigation: {
        nextEl: slideshow.querySelector('.swiper-button-next'),
        prevEl: slideshow.querySelector('.swiper-button-prev'),
      },
      autoplay: autoplayEnabled && slideCount > 1 ? {
        delay,
        disableOnInteraction: true,
      } : false,
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initHfmSlideshows());
document.addEventListener('shopify:section:load', (event) => initHfmSlideshows(event.target));